export const NOTIFICATION_DURATION = {
    error: 10000,
    success: 5000,
    warning: 7000
};
export const NOTIFICATION_MESSAGES = {
    success: 'Success',
    error: 'Something went wrong'
};
export const NOTIFICATION_TITLES = {
    success: 'SUCCESS',
    warning: 'WARNING',
    error: 'ERROR'
};
